/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Voucher_CurrencyInputs */

const en_billing_voucher_currency = /** @type {(inputs: Billing_Voucher_CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vouchers work with IDR checkout only.`)
};

const id_billing_voucher_currency = /** @type {(inputs: Billing_Voucher_CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voucher hanya berlaku untuk pembayaran IDR.`)
};

/**
* | output |
* | --- |
* | "Vouchers work with IDR checkout only." |
*
* @param {Billing_Voucher_CurrencyInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const billing_voucher_currency = /** @type {((inputs?: Billing_Voucher_CurrencyInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Voucher_CurrencyInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_billing_voucher_currency(inputs)
	return en_billing_voucher_currency(inputs)
});